import React from 'react';
import { useTranslatedContent } from '../../hooks/useTranslatedContent';
import TrainingCourseCard from './courses/TrainingCourseCard';
import { Server, Shield, Cloud, Key, Settings, Users, Mail, Network } from 'lucide-react';

const OfficialTraining = () => {
  const { t } = useTranslatedContent(['training', 'request']);

  const courseIcons = {
    zimbra: Mail,
    lemonldap: Shield,
    nextcloud: Cloud,
    openldap: Key,
    itsm: Settings,
    fusion: Users,
    proxmox: Server,
    opnsense: Network
  };

  const solutions = [
    'zimbra',
    'lemonldap',
    'nextcloud',
    'openldap',
    'itsm',
    'fusion',
    'proxmox',
    'opnsense'
  ];

  return (
    <div className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900">{t('training:title')}</h2>
          <p className="mt-4 text-xl text-gray-600">
            {t('training:subtitle')}
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-8">
          {solutions.map((solution) => {
            const course = t(`training:courses.${solution}.systemAdmin`, { returnObjects: true });
            if (!course) return null;

            return (
              <TrainingCourseCard
                key={solution}
                course={{
                  ...course,
                  icon: courseIcons[solution as keyof typeof courseIcons]
                }}
              />
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600">
            {t('training:customTraining.text')}{' '}
            <button 
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-blue-600 font-semibold hover:text-blue-700"
            >
              {t('training:customTraining.buttonText')}
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default OfficialTraining;